import Seller from "./From/Seller";
import Target from "./To/Target";
import Shipping from "./Shipping";
import Comment from "./Comment";
import React, {Fragment, useState, useEffect} from "react";
import BoxEditor from "../../BoxEditor";
import Buttons from "../Elements/Buttons";
import List from "./List";
import TargetList from "./Picking/TargetList";
import AccountDate from "./Invoice/Dates/AccountDate";
import Other from "./Other";
import {loadComponent} from "../../../../utils/components";
import Source from "./From/Source";
import {get} from "../../../../utils/dotutils";

const Data = (componentProps) => {
    const [linked_stores, setLinkedStores] = useState(0);
    const [loading, setLoading] = useState(false);

    const {props, state, parent} = componentProps;
    const {hidden, labels} = props;
    const inputProps = props.getProps("seller");

    let loadLinkedStores;

    useEffect(() => {
        if (get(props, "values.seller.partner_id")) {
            loadLinkedStores = loadComponent("componentlist", {
                component: "location",
                filter: [
                    {
                        field: "store.serviceprovider",
                        value: "linked_store"
                    },
                    {
                        field: "partner",
                        value: props.values.seller.partner_id
                    }
                ]
            });
            loadLinkedStores.then((list) => {
                setLinkedStores(list.items.length);
            })
        }
        return () => {
            loadLinkedStores && loadLinkedStores.abort();
        }
    });

    const col = linked_stores ? 3 : 4;

    return <div className="row form-row">
        <div className={"col-md-" + col}>
            <Seller {...componentProps} />
        </div>
        {!!linked_stores && <div className={"col-md-" + col}>
            <Source {...componentProps} />
        </div>}
        <div className={"col-md-" + col}>
            <Target {...componentProps} />
        </div>
        <AccountDate
            col={col}
            {...componentProps}
            isClearable={true}
        />
    </div>;
}

export default (componentProps) => {
    const {props, state, parent} = componentProps;
    const {hidden, labels, actionButtons} = props;
    const Editor = props.editor || BoxEditor;
    return <Fragment>
        <List boxid={props.componentEditor + "ListBox"} {...componentProps} />
        <Editor
            theme="default"
            footer={<Fragment>
                <Buttons {...componentProps} />
            </Fragment>}
        >
            {
                props.values.id && <form onSubmit={props.handleSubmit}>
                    <Other {...componentProps} tag={Fragment} />
                    <Data {...componentProps} />
                    <div className="row form-row">
                        <Shipping {...componentProps} />
                        {/*<Notenum {...componentProps} />*/}
                    </div>
                    <Comment {...componentProps} />
                    <TargetList {...componentProps} />
                </form>
            }
        </Editor>
    </Fragment>;
}